import { Avatar as MuiAvatar, Box, SxProps } from '@mui/material'

import { DefaultElementProps } from 'common/interfaces'

import { Avatar as AvatarProps } from './interface'

const styles: Record<string, SxProps> = {
  box: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
  },
  avatar: {
    width: {
      xs: '72px',
      sm: '88px',
    },
    height: {
      xs: '72px',
      sm: '88px',
    },
  },
}

export default function Avatar({ alt, src }: AvatarProps & DefaultElementProps): JSX.Element {
  return (
    <Box className="avatar-wrap" sx={styles.box}>
      <MuiAvatar src={src} alt={alt} sx={styles.avatar} />
    </Box>
  )
}
